

export const BaseUrl = "https://api.pardnerpal.co.uk/api/";

// export const BaseUrl = "http://localhost:3001/api/";


export const Signin = "admin-sign-in";
export const Forgot_Password = "change-password-admin";
export const Reset_Password = "reset-password-admin";
export const Users = "admin/user-list";
export const User_Detail = "admin/user-detail";
export const User_Enable = "admin/user-enable";
export const User_Disable = "admin/user-disable";
export const User_Update = "admin/user-update";
export const Group_Disable = "admin/group-disable";
export const Group_Enable = "admin/group-enable";
export const ImageBase = "https://api-staging.pardnerpal.co.uk/api/uploads/profile/";
export const Change_Password = "admin/change-password";
export const Admin_Dashboard = "admin/dashboard";
export const VERIFY_USER = "verify-account";
export const VERIFY_LINK = "check-link-validation";

// Stats User
export const User_Today = "admin/user-today";
export const User_Week = "admin/user-week";
export const User_month = "admin/user-month";
export const User_quater = "admin/user-quater";
export const User_Year = "admin/user-year";


// Stats Groups
export const Group_Today = "admin/group-today";
export const Group_Week = "admin/group-week";
export const Group_month = "admin/group-month";
export const Group_quater = "admin/group-quater";
export const Group_Year = "admin/group-year";
// Group details
export const GroupList = "admin/group-list";

export const Group_Detail = "admin/group-details";
export const GroupDetailWithParticipants = "/group-details-with-participants";
export const GroupUserPayment = "/get-user-payment";

export const ExportPaymentAll = "admin/export-all-payment-admin";

export const getPaymentbyDate = "admin/get-payment-bydate-admin";

export const createCms = "create-cms";
export const getCms = "get-cms";

export const userGrouplist = "admin/user-group-list";

